import React from 'react';
import { useNavigate } from 'react-router-dom';
import { orderDetailsPath } from '@/constants/routes';
import { OnwardBreadcrumbActive, OnwardBreadcrumbInactive, OnwardBreadcrumbSpacer } from '../Breadcrumbs';

/**
 * Parent/child breadcrumb for the order details page. `orders` is the parent-first
 * ordered group (see orderLinkedOrders); `parentId` is the group root
 * (original_order_id ?? order_id of the current order).
 *
 * Renders:
 *  - "My Orders > {parent}" when the current order IS the parent (or standalone)
 *  - "My Orders > {parent} > {current}" when viewing a child order
 *
 * "My Orders" returns to the previous list; the parent crumb (when not active)
 * navigates to the parent order, which re-loads everything via the route param.
 */
const LinkedOrdersBreadcrumb = ({ orders, currentOrderId, parentId }) => {
    const navigate = useNavigate();

    const parent = orders.find((o) => o.order_id === parentId) ?? orders[0];
    if (!parent) return null;

    const current = orders.find((o) => o.order_id === currentOrderId) ?? parent;
    const viewingParent = current.order_id === parent.order_id;

    return (
        <React.Fragment>
            <OnwardBreadcrumbInactive onClick={() => navigate(-1)}>My Orders</OnwardBreadcrumbInactive>
            <OnwardBreadcrumbSpacer />
            {viewingParent ? (
                <OnwardBreadcrumbActive>{parent.order_number}</OnwardBreadcrumbActive>
            ) : (
                <React.Fragment>
                    <OnwardBreadcrumbInactive onClick={() => navigate(orderDetailsPath(parent.order_id))}>
                        {parent.order_number}
                    </OnwardBreadcrumbInactive>
                    <OnwardBreadcrumbSpacer />
                    <OnwardBreadcrumbActive>{current.order_number}</OnwardBreadcrumbActive>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default LinkedOrdersBreadcrumb;
